module.exports = __webpack_public_path__ + "img/shuaishuai2.672915ce.png";